module.exports = __webpack_public_path__ + "static/media/admin_canvas_fabric_icon.324f8309.svg";